import { datadogRum } from "@datadog/browser-rum";

export const logError = (error: unknown, context: any) => {
  try {
    datadogRum.addError(error, {
      context,
    });
  } catch (error) {
    /* empty */
  }
};
